export interface IChatOperatorParticipantDto {
    name: string;
    userId: string;
}

export interface ICreateChatParticipantDto {
    organizationId?: string;
    // Defaults to `${driverFullName} - ${organizationName}` when omitted
    name?: string;
    // Required unless the caller is the driver themselves (inferred from their own user id)
    driverId?: string;
    driverName?: string;
    participants?: IChatOperatorParticipantDto[];
}

export interface IUpdateChatParticipantDto {
    name?: string;
    participants?: IChatOperatorParticipantDto[];
    enabled?: boolean;
}

export interface IChatParticipantOutputDto {
    id: string;
    name: string;
    driverId: string;
    driverName: string;
    driverUserId: string;
    organizationId: string;
    // Counterpart's name when the driver is the one reading the conversation
    organizationName?: string;
    participants: IChatOperatorParticipantDto[];
    enabled: boolean;
    // When this chat was last read by the caller (not by any other participant)
    lastReadAt?: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface INotifyChatParticipantOutputDto {
    // Dispositivos a los que se encoló la notificación; cero significa que no había a quién avisarle
    queued: number;
}
